<div class="center">
    <!-- <img class="center-img" src="assets/images/skiddo-logo.jpg" /> -->
    <br>
    <div class="center-content">
        <h5><b>You don't have access to this page</b></h5>
        <p>
            Please contact your Admin regarding this issue.
        </p>
    </div>
    <div class="center-button">
        <button class="btn btn-danger" type="button">BACK</button>
    </div>
</div>